export class SpecialEventType {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
}

export default SpecialEventType;